import { React } from "react";
import { Container } from 'react-bootstrap';

const DatosExperiencia = ({ experiencia, ruta }) => {
    return (
        <div className="pb-3 container" style={{ paddingTop: '4rem' }}>
            <div className="imatge-banner" style={{ backgroundImage: "url('" + ruta + "/experiencias/" + experiencia.id + "/" + experiencia.imagen + "')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: "cover" }} >
            </div>
            <h1 className="text-center mb-5">{experiencia.elnombre}</h1>
            <Container>
                <div className="noticia-individual-descripcio-llarga">
                    <div dangerouslySetInnerHTML={{ __html: experiencia.eltexto }}></div>
                </div>
            </Container>
        </div>
    );
}

export default DatosExperiencia;
